import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { selectCurrentCompanyId, selectCurrentProjectId } from 'reduxStore/project/projectSelector';
import { useFetchGrowthbook } from 'shared/hooks/useFetchGrowthbook';
import { GrowthBookProvider } from '@growthbook/growthbook-react';
import { growthbook } from 'config/growthbook';

type WBGrowthBookProviderProps = {
  children: React.JSX.Element;
};

export const WBGrowthBookProvider: React.FC<WBGrowthBookProviderProps> = ({ children }) => {
  const { loading } = useFetchGrowthbook();
  const surveyId = useSelector(selectCurrentProjectId)?.toString();
  const companyId = useSelector(selectCurrentCompanyId);

  useEffect(() => {
    const attributes: Record<string, string | number | undefined> = {
      surveyId,
      project_id: Number(surveyId),
    };

    if (companyId != null) {
      attributes.company = companyId.toString();
    }

    growthbook.setAttributes(attributes);
  }, [surveyId, companyId]);

  return (
    <>{!loading && <GrowthBookProvider growthbook={growthbook}>{children}</GrowthBookProvider>}</>
  );
};
